import { IconButton } from '@mui/material';
import { useIntl } from 'react-intl';

import LinkUnstyled from 'components/@common/LinkUnstyled';
import Icon from 'components/@icons/Icon';

interface Props {
  href: string;
}

const BackButton = ({ href }: Props) => {
  const intl = useIntl();
  return (
    <IconButton
      size="small"
      component={LinkUnstyled}
      aria-label={intl.formatMessage({ id: 'navigation.back' })}
      href={href}
    >
      <Icon name="ArrowLeft" rotateInArabic />
    </IconButton>
  );
};

export default BackButton;
